"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import Api from "../../api/api";
import generalFormatter from "../../formatters/general";
const TrainingEnvironmentToC = React.createClass({
  propTypes: {
    showLessonToC: React.PropTypes.func.isRequired,
    lessons: React.PropTypes.array.isRequired,
    trainingUserToken: React.PropTypes.string.isRequired,
    accountId: React.PropTypes.number.isRequired
  },
  close() {
    this.props.showLessonToC(false);
  },
  redoLesson() {
  },
  continueLesson() {
    this.close();
  },
  startUpcomingLesson() {
    Api.TrainingEnvironment.completeLesson(this.props.accountId, this.props.trainingUserToken);
    this.close();
  },
  formatDate(date) {
    return generalFormatter.shortDate(date);
  },
  render: function() {
    const lessons = this.props.lessons.map((lesson, i) => __spreadProps(__spreadValues({}, lesson), { num: i + 1 })) || [];
    const completedLessons = lessons.filter((a) => a.completed_at);
    const [currentLesson, ...upcomingLessons] = lessons.filter((a) => !a.completed_at);
    const count = completedLessons.length;
    const total = lessons.length;
    const units = total === 1 ? "lesson" : "lessons";
    const hasLoadedTrainingLessonsYet = total > 0;
    return /* @__PURE__ */ React.createElement("div", { className: "training-modal" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__background", onClick: this.close }), hasLoadedTrainingLessonsYet ? /* @__PURE__ */ React.createElement("div", { className: "training-modal__content" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__card" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__header" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__title" }, "Completed ", count, " of ", total, " ", units), /* @__PURE__ */ React.createElement("i", { className: "training-modal__close fi-x", onClick: this.close })), /* @__PURE__ */ React.createElement("div", { className: "training-item__list" }, completedLessons.map(this.viewCompletedItem), this.viewCurrentItem(currentLesson), upcomingLessons.map(this.viewUpcomingItem)))) : null);
  },
  viewCompletedItem({ title, description, num, completed_at } = {}) {
    return /* @__PURE__ */ React.createElement("div", { key: title, className: "training-item" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__thumbnail" }, /* @__PURE__ */ React.createElement("span", { className: "training-item__check fi-check" }), /* @__PURE__ */ React.createElement("span", { className: "training-item__image training-item__image--complete" }, this.viewThumbnailImage(num))), /* @__PURE__ */ React.createElement("div", { className: "training-item__content" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "training-item__description" }, description), /* @__PURE__ */ React.createElement("div", { className: "training-item__controls" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__completion" }, "Completed ", this.formatDate(completed_at)))));
  },
  viewCurrentItem({ title, description, num } = {}) {
    if (!title) {
      return /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement("div", { key: title, className: "training-item training-item--current" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__thumbnail" }, /* @__PURE__ */ React.createElement("span", { className: "training-item__image" }, this.viewThumbnailImage(num))), /* @__PURE__ */ React.createElement("div", { className: "training-item__content" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "training-item__description" }, description), /* @__PURE__ */ React.createElement("div", { className: "training-item__controls" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "training-item__button button--confirmation",
        onClick: this.continueLesson
      },
      "Continue this lesson"
    ))));
  },
  viewUpcomingItem({ title, description, num } = {}) {
    return /* @__PURE__ */ React.createElement("div", { key: title, className: "training-item training-item--disabled" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__thumbnail" }, /* @__PURE__ */ React.createElement("span", { class: "training-item__image" }, this.viewThumbnailImage(num))), /* @__PURE__ */ React.createElement("div", { className: "training-item__content" }, /* @__PURE__ */ React.createElement("div", { className: "training-item__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "training-item__description" }, description)));
  },
  viewThumbnailImage(num) {
    return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 400 200", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "myGradient", gradientTransform: "rotate(90)" }, /* @__PURE__ */ React.createElement("stop", { offset: "0%", stopColor: "#3C4F59CC" }), /* @__PURE__ */ React.createElement("stop", { offset: "100%", stopColor: "#3C5F69" }))), /* @__PURE__ */ React.createElement("rect", { x: "0", y: "0", width: "400", height: "200", fill: "url(#myGradient)" }), /* @__PURE__ */ React.createElement(
      "text",
      {
        x: "50%",
        y: "50%",
        dominantBaseline: "middle",
        textAnchor: "middle",
        style: { fontSize: "42px", fontWeight: "600", fontFamily: "Helvetica Neue, Arial, sans-serif" },
        fill: "white"
      },
      "Lesson " + num
    ));
  }
});
export default TrainingEnvironmentToC;
